module.exports = __webpack_public_path__ + "static/media/vicepresident.b75e6157.jpg";